// extracted by mini-css-extract-plugin
export default {"remove":"FormEditor_remove__JGc9e"};